const GLOBAL_OBJ = globalThis;

export { GLOBAL_OBJ };
//# sourceMappingURL=worldwide.js.map
